import { render } from "./ribbons_advance.vue?vue&type=template&id=440dd003"
import script from "./ribbons_advance.vue?vue&type=script&lang=js"
export * from "./ribbons_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__